export default "__VITE_ASSET__B3RCTat4__"